import React from "react";
import CrunchIcon from "./../assets/crunch.png";
import AngelIcon from "./../assets/angel.png";
import QuoraIcon from "./../assets/quora.png";
import { SocialIcon as SocialIconLib } from "react-social-icons";
import { CSSProperties, DetailedHTMLProps, AnchorHTMLAttributes } from "react";
import { classNames } from ".";
interface SVG {
  icon: string;
  mask: string;
  color: string;
  path: string;
}
interface SocialIconProps
  extends DetailedHTMLProps<
    AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  > {
  className?: string;
  bgColor?: string;
  fgColor?: string;
  label?: string;
  network?: string;
  url?: string;
  defaultSVG?: SVG;
  style?: CSSProperties;
}

const additionalSocialIcons = {
  "angel.co": AngelIcon,
  "quora.com": QuoraIcon,
  "crunchbase.com": CrunchIcon,
};

export const SocialIcon = (props: SocialIconProps) => {
  const clickHandler = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(props.url, "_blank");
  };
  for (let icon of Object.keys(additionalSocialIcons)) {
    if (props.network === icon || (props.url && props.url.includes(icon))) {
      const hasCustomSize = props.style?.width || props.style?.height;
      return (
        <img
          className={
            hasCustomSize ? "mx-2 rounded-md" : "w-12 h-12 p-2 mx-2 rounded-2xl"
          }
          style={hasCustomSize ? props.style : undefined}
          // @ts-ignore
          src={additionalSocialIcons[icon]}
          alt={icon}
        />
      );
    }
  }

  if (props.url?.includes("twitter.com")) {
    return (
      <SocialIconLib
        {...props}
        url="x.com"
        className={classNames("mx-2", props.className ?? "")}
        onClick={clickHandler}
      ></SocialIconLib>
    );
  }

  return (
    <SocialIconLib
      {...props}
      className={classNames("mx-2", props.className ?? "")}
      onClick={clickHandler}
    ></SocialIconLib>
  );
};
